import {Module} from 'vuex';
import {
    fetchEnterpriseFilterView,
    getReachDataList,
    getReachDataTotal,
} from "@/js/user-share-data.service";

/**
 * 用户触达数据模块
 * @type {Module}
 */
export const userReach = {
    namespaced: true,
    state: {
        // 案例触达数据
        caseReachData: [
            {
                title: '今日触达',
                key: 'today',
                value: 0
            }, {
                title: '本月触达',
                key: 'month',
                value: 0
            }, {
                title: '累计触达',
                key: 'total',
                value: 0
            }
        ],
        // 口碑触达数据
        commentReachData: [
            {
                title: '今日触达',
                key: 'today',
                value: 0
            }, {
                title: '本月触达',
                key: 'month',
                value: 0
            }, {
                title: '累计触达',
                key: 'total',
                value: 0
            }
        ],
        // 激活的排行
        activeRankKey: 'region',
        // 排行筛选参数
        rankSelectParams: {
            region_Id: undefined, // number | string, // 大区id 多个用英文逗号分隔
            start_date: undefined, // string, // 开始时间
            end_date: undefined, //string, // 结束时间
            order: JSON.stringify({total_desc: 1, total_asc: 0}), //  {        total_desc: 1 | 0, // 总数升序 0：否；1：是        total_asc: 1 | 0, // 总数降序 0：否；1：是
        },
        // 页面表格排行数据
        rankResultList: [],
        // 列表总数
        rankResultTotal: 0,
        // 列表分页
        rankResultPage: 0,
        rankDefaultPage: 0,
        rankResultPageSize: 20,
        // 人员筛选属性
        // 用户id
        tp5XcxUserid: undefined,

        rankSelectAreaResult: [],
    },
    mutations: {
        /**
         * 设置用户ID
         * @param state
         * @param typeAction
         * @constructor
         */
        SET_USER_ID(state, typeAction) {
            state.tp5XcxUserid = typeAction.id;
        },
        RESET_SCREEN(state) {
            state.rankSelectParams = {
                region_Id: undefined, // number | string, // 大区id 多个用英文逗号分隔
                start_date: undefined, // string, // 开始时间
                end_date: undefined, //string, // 结束时间
                order: JSON.stringify({total_desc: 1, total_asc: 0}), //  {        total_desc: 1 | 0, // 总数升序 0：否；1：是        total_asc: 1 | 0, // 总数降序 0：否；1：是
            }
            state.rankResultTotal = 0;
            state.rankResultPage = 0;
            state.rankResultPageSize = 20;
        },
        CHANGE_REACH_TOTAL(state, typeAction) {
            /**
             * @type {{ month: number; today: number;total: number;}}
             */
            const {result} = typeAction;
            state.caseReachData = state.caseReachData.map((i) => {
                i.value = result[i.key];
                return i;
            })
        },
        CHANGE_COMMENT_REACH_TOTAL(state, typeAction) {
            /**
             * @type {{ month: number; today: number;total: number;}}
             */
            const {result} = typeAction;
            state.commentReachData = state.commentReachData.map((i) => {
                i.value = result[i.key];
                return i;
            })
        },
        /**
         * 切换激活的排行
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_ACTIVE_RANK(state, typeAction) {
            state.activeRankKey = typeAction.key;
        },
        /**
         * 改变表格资源
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_TABLE_RESULT_LIST(state, typeAction) {
            const {lists, total, push, page} = typeAction;
            // 区分是否第一页
            push ? state.rankResultList.push(...lists) : (state.rankResultList = lists);
            state.rankResultTotal = total;
            state.rankResultPage = push ? page : state.rankDefaultPage + 1;
        },
        /**
         * 改变排行表单时间内容
         * @param state
         * @param {{ time?:{start:string; end:string} }} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_TIME(state, typeAction) {
            const {time = {}} = typeAction;
            const {start, end} = time;
            state.rankSelectParams.start_date = start;
            state.rankSelectParams.end_date = end;
        },
        /**
         * 改变排行表单排序内容
         * @param state
         * @param {{order?:string}} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_ORDER(state, typeAction) {
            const {order} = typeAction;
            state.rankSelectParams.order = order;
        },
        /**
         * 设置数据筛选配置数据
         * @param state
         * @param typeAction
         * @constructor
         */
        SET_SELECT_DATE_OPTION(state, typeAction) {
            const {result} = typeAction;
            state.rankSelectAreaResult = result;
            // state.rankSelectJobResult = office;
        },
        /**
         * 改变排行表单数据筛选内容
         * @param state
         * @param {{cancel?:boolean}} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_DATE(state, typeAction) {
            const {cancel} = typeAction;
            // 大区IDS
            state.rankSelectParams.region_Id = cancel ? undefined : state.rankSelectAreaResult.filter(i => i.select)
                .reduce((pre, item) => `${item.region_value},${pre}`, '');
        },
        /**
         * 改变大区的选择
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_AREA_SELECT(state, typeAction) {
            const {area: {region_value, select} = {}} = typeAction;
            state.rankSelectAreaResult = state.rankSelectAreaResult.map(i => {
                if (region_value) {
                    i.region_value === region_value && (i.select = !select);
                } else {
                    i.select = false;
                }
                return i;
            });

        },
    },
    actions: {
        /**
         * 获取统计数据
         * @return {Promise<void>}
         */
        async getReachData({commit, state}, typePayload) {
            commit({type: "SET_USER_ID", id: typePayload.id});
            const {result: allResult} = await getReachDataTotal(state.tp5XcxUserid, 0);
            commit({type: 'CHANGE_REACH_TOTAL', result: allResult});
            const {result: commentResult} = await getReachDataTotal(state.tp5XcxUserid, 1);
            commit({type: 'CHANGE_COMMENT_REACH_TOTAL', result: commentResult});
        },
        /**
         * 获取排行数据
         * @return {Promise<void>}
         */
        async fetchEnterpriseRankAction({state, commit}, typePayload) {
            commit('loadSwitch', true, {root: true});
            // 默认是拉取第一页
            const {push = false, caseType} = typePayload;
            console.log(caseType, 'caseType')
            // 请求数据
            const requestDate = {
                type: state.activeRankKey,
                page: push ? state.rankResultPage : state.rankDefaultPage,
                row: state.rankResultPageSize,
                ...state.rankSelectParams,
                tp5xcxuserid: state.tp5XcxUserid,
                is_priase: caseType,
            };
            const {result: {list, total}} = await getReachDataList(requestDate);
            console.log(list, total, 'lists, total')
            // 填充数据
            commit({type: 'CHANGE_TABLE_RESULT_LIST', lists: list, page: requestDate.page + 1, total, push});

            commit('loadSwitch', false, {root: true})
        },
        /**
         * 请求排行筛选数据筛选配置数据
         * @param commit
         * @param state
         * @return {Promise<void>}
         */
        async fetchEnterpriseFilterAction({commit, state}) {
            const {result} = await fetchEnterpriseFilterView(state.tp5XcxUserid);
            commit({type: 'SET_SELECT_DATE_OPTION', result})
        }
    },
    getters: {
        /**
         * 是否加载完毕
         * @param state
         */
        loadMoreEnd: (state) => {
            return (state.rankResultPageSize * state.rankResultPage) >= state.rankResultTotal
        }
    },
}

